var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('div',[_vm._v("Bye-bye...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }